<template>
  <div class="flex w-full items-center justify-between" style="position: relative;">
    <div class="w-full flex justify-start items-center">
      <vs-avatar
        :src="avatar"
        :text="avatarText"
        class="flex-shrink-0 mr-2"
        :color="AISEA_COLOR.LIGHT_BLUE" 
        size="30px"
        style="cursor: default;"
      />
      <div class="ellipsis">{{ params.value }}</div>
    </div>
    <div class="mr-4" >
      <vs-tooltip text="アプリアカウント発行済" position="top" >
        <vs-icon v-if="params.data.enterprise_crew_account" icon="verified_user" size="15px" :color="AISEA_COLOR.BLUE" style="margin-left: 0.6rem;" />
      </vs-tooltip>
      <vs-tooltip text="アプリアカウント未発行" position="top" >
        <vs-icon v-if="!params.data.enterprise_crew_account" icon="privacy_tip" size="15px" :color="AISEA_COLOR.LIGHT_GRAY" style="margin-left: 0.6rem;" />
      </vs-tooltip>
    </div>
  </div>
</template>

<script>
import { storage } from "@/firebase/firebaseConfig";
import { ColorMixin } from "@/mixins";
export default {
  name: "CellRendererLink",
  mixins: [ColorMixin],
  data() {
    return {
      avatar: null,
      avatarText: ""
    };
  },
  created() {
    if ( this.params.data.picture ) {
      storage
        .child(this.params.data.picture.thumbnail_path)
        .getDownloadURL()
        .then(response => {
          this.avatar = response;
        });
    } else {
      // this.avatarText = this.params.data.name ? this.params.data.name.charAt( 0 ) : '';
    }
  },
};
</script>

<style lang="scss" scoped>
.ellipsis {
  max-width: calc(100% - 30px - 15px - 1rem);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>

